/**
 * sanitizeHtml.js
 *
 * Sanitização de HTML vindo de fontes não confiáveis (ex.: conteúdo gerado
 * pelo editor Quill em templates de documentos/mensagens) antes de ser
 * renderizado via dangerouslySetInnerHTML, para evitar XSS armazenado.
 */

import DOMPurify from 'dompurify';

/**
 * Sanitiza uma string HTML, removendo scripts e atributos perigosos.
 *
 * @param {string} html - HTML potencialmente não confiável
 * @returns {string} HTML sanitizado, seguro para renderização
 */
export function sanitizeHtml(html) {
  return DOMPurify.sanitize(html ?? '', { USE_PROFILES: { html: true } });
}
